import React from 'react';
import './css/Toast.css';

const Toast = ({ type = 'success', title, message, onClose, isVisible = true }) => {
  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return (
          <div className="toast-icon-wrapper toast-icon-success">
            <div className="toast-icon-inner toast-icon-inner-success">
              <i className="fa-solid fa-check"></i>
            </div>
          </div>
        );
      case 'warning':
        return (
          <div className="toast-icon-wrapper toast-icon-warning">
            <div className="toast-icon-inner toast-icon-inner-warning">
              <i className="fa-solid fa-exclamation"></i>
            </div>
          </div>
        );
      case 'error':
        return (
          <div className="toast-icon-wrapper toast-icon-error">
            <div className="toast-icon-inner toast-icon-inner-error">
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
        );
      case 'contact-admin':
        return (
          <div className="toast-icon-wrapper toast-icon-warning">
            <div className="toast-icon-inner toast-icon-inner-warning">
              <i className="fa-solid fa-circle-info"></i>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`toast toast-${type}`}>
      {getIcon()}
      <div className="toast-content">
        <h3 className="toast-title">{title}</h3>
        <p className="toast-message">{message}</p>
      </div>
      {onClose && (
        <button className="toast-close" onClick={onClose} aria-label="Close">
          <i className="fa-solid fa-xmark"></i>
        </button>
      )}
    </div>
  );
};

export default Toast;
